<div class="info-item" [class.info-item--with-label]="label()" [class.info-item--inline]="inline()">
    @if (label()) {
        <span class="info-item__label">{{ label() }}</span>
    }
    <span class="info-item__value">
        @if (icon()) {
            <i [class]="icon() + ' info-item__icon'"></i>
        }
        {{ value() ?? '—' }}
    </span>
</div>
